document.addEventListener("DOMContentLoaded", function() {
    let buttonBuyNow = document.querySelectorAll("[data-grid-buy-button-permalink]");
    let modalZipcode = document.querySelector("[data-popup-zip-locator]");
    let form = document.querySelectorAll("[data-grid-form]");

    const triggerModal = () => {
        buttonBuyNow.forEach((button) => {
            if (button) {
                button.addEventListener("click", (evt) => {
                    evt.preventDefault();
                    if (window.zipLocator.zip && window.zipLocator.match) {
                        location.href = button.href;
                    } else {
                        const zipLocatorTrigger = modalZipcode;
                        if (zipLocatorTrigger) zipLocatorTrigger.click();
                    }
                });
            }
        });
    }

    const updateButtonBuyNow = () => {
        form.forEach((form) => {
            let button = form.querySelector("[data-grid-buy-button-permalink]");
            let addButton = form.querySelector("[data-add-to-cart-variant]");
            let quantityInput = form.querySelector("[data-quantity-input]");

            if (!button) return;

            const variant = addButton.getAttribute("data-add-to-cart-variant");
            const quantity = quantityInput ? quantityInput.value : 1;
            const context = {
                curSite: localStorage.getItem("CURRENT_PARTNER_STORAGE_KEY") ?? null,
                zip: window.zipLocator.zip,
                matchedConsultant: window.zipLocator.match,
                isPartner: window.customer.isPartner,
                betterwarePlusId: window.customer.betterwarePlusId,
            };

            const shopUrl = button.dataset.shopUrl;
            var permalinkUrl =
                shopUrl +
                "/cart/add?id=" +
                variant +
                "&quantity=" +
                quantity +
                "&attributes[context]=" +
                btoa(JSON.stringify(context));

            button.href = permalinkUrl;
        });
    }

    const Quantity = () => {
        /*
        form.forEach((form) => {
            let increase = form.querySelector("[data-increase-quantity]");
            let decrease = form.querySelector("[data-decrease-quantity]");
            let input = form.querySelector("[data-quantity-input]");

            increase.addEventListener(
                "click",
                function (e) {
                    e.preventDefault();
                    let v = parseInt(input.value, 10);
                    v = isNaN(v) ? 0 : v;
                    v++;
                    input.value = v;
                    console.log(e, "evento Quantity")
                    input.dispatchEvent(new Event("change"));
                }.bind(this)
            );
            decrease.addEventListener(
                "click",
                function (e) {
                    e.preventDefault();
                    let v = parseInt(input.value, 10);
                    v = isNaN(v) ? 0 : v;
                    v--;
                    v = Math.max(1, v);
                    input.value = v;
                    console.log(e, "evento Quantity")
                    input.dispatchEvent(new Event("change"));
                }.bind(this)
            );
        });
        */
    }

   const products_random = () => {
        let products = document.querySelectorAll('.product-grid-slide');

        let productsArray = Array.from(products);
        productsArray.sort(function() { return 0.5 - Math.random(); });

        let productLimit = 5; 
        let displayedProducts = productsArray.slice(0, productLimit);

        if (displayedProducts.length < productLimit) {
            let additionalProducts = productsArray.slice(productLimit);
            additionalProducts.forEach(function(product) {
                if (displayedProducts.length < productLimit) {
                    displayedProducts.push(product);
                }
            });
        }

        products.forEach(function(product) {
            product.style.display = 'none';
        });

        displayedProducts.forEach(function(product) {
            product.style.display = 'inline-block';
        });
        let flickityGrid = document.querySelector('.flickity-grid');
        if (flickityGrid) {
            flickityGrid.style.overflowX = 'auto';
            flickityGrid.style.whiteSpace = 'nowrap';
            flickityGrid.style.msOverflowStyle = 'none'; 
            flickityGrid.style.scrollbarWidth = 'none';
        }
    }

    products_random();
    triggerModal();
    updateButtonBuyNow();
    Quantity();
});